// client.ts
import { ApolloClient, ApolloLink, makeVar } from "@apollo/client";
import { SessionStorageWrapper, persistCache } from "apollo3-cache-persist";
import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";

import { CustomToastComponent } from "./components/shared";
import { ErrorLink } from "@apollo/client/link/error";
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs";
import { cache } from "./cache/CacheConfig";
import { toast } from "react-toastify";

if (import.meta.env.VITE_APP_ENV === "dev") {
  loadDevMessages();
  loadErrorMessages();
}

export const isDarkModeVar = makeVar(localStorage.getItem("darkMode"));

const errorsToNotDisplay = [
  "Wrong credentials!",
  "Invalid email address!",
  "No credentials or missing field!",
];

await persistCache({
  cache,
  storage: new SessionStorageWrapper(window.sessionStorage),
});

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL as string;

const uploadLink = new UploadHttpLink({
  uri: `${BACKEND_URL}`,
  credentials: "include",
  headers: {
    "Apollo-Require-Preflight": "true",
    "Authorization": sessionStorage.getItem("token") ?? "",
  },
});

const errorLink = new ErrorLink(({ error }) => {
  toast.dismiss();
  if (error) {
    const maybeErrors = (error as any).errors;
    if (Array.isArray(maybeErrors)) {
      maybeErrors.forEach((e: any) => {
        const message = e.message;
        if (!errorsToNotDisplay.includes(message)) {
          toast(CustomToastComponent, {
            toastId: "gqlError",
            data: {
              title: message,
              type: "error",
            },
          });
        }
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(e.locations)}, Path: ${e.path}`
        );
      });
    } else {
      console.log(`[Network error]: ${error}`);
      // Optionally: toast.error(`[Network Error]:\n ${error}`, { toastId: "gqlNetworkError" });
    }
  }
});

const authLink = new ApolloLink((operation, forward) => {
  const token = sessionStorage.getItem("token") ?? "";
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      "Apollo-Require-Preflight": "true",
      ...(operation.operationName
        ? { "x-apollo-operation-name": operation.operationName }
        : {}),
      "Authorization": token,
    },
  }));
  return forward(operation);
});

const link = ApolloLink.from([authLink, errorLink, uploadLink]);

export const client = new ApolloClient({
  link,
  cache,
  devtools: {
    enabled: import.meta.env.VITE_APP_ENV === "dev",
  },
});
